import { Routes, Route, Navigate } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import CardMachinesPage from "@/pages/CardMachinesPage";
import CardMachineProductPage from "@/pages/CardMachineProductPage";
import EposSystemsPage from "@/pages/EposSystemsPage";
import EposRegisterPage from "@/pages/EposRegisterPage";
import OnlinePaymentsPage from "@/pages/OnlinePaymentsPage";
import VirtualTerminalPage from "@/pages/VirtualTerminalPage";
import OnlineOrderingPage from "@/pages/OnlineOrderingPage";
import MerchantCashAdvancePage from "@/pages/MerchantCashAdvancePage";
import PaymentGatewayPage from "@/pages/PaymentGatewayPage";
import AboutPage from "@/pages/AboutPage";
import PurposeBeyondPaymentsPage from "@/pages/PurposeBeyondPaymentsPage";
import IndustryPage from "@/pages/IndustryPage";
import IndustriesHubPage from "@/pages/IndustriesHubPage";
import IntegrationHubPage from "@/pages/IntegrationHubPage";
import PlatformIntegrationPage from "@/pages/PlatformIntegrationPage";
import ApiPage from "@/pages/ApiPage";
import PartnerProgrammePage from "@/pages/PartnerProgrammePage";
import CareersPage from "@/pages/CareersPage";
import ReferAFriendPage from "@/pages/ReferAFriendPage";
import AboutSubPage from "@/pages/AboutSubPage";
import CaseStudiesPage from "@/pages/CaseStudiesPage";
import CaseStudyPage from "@/pages/CaseStudyPage";
import FAQsPage from "@/pages/FAQsPage";
import ReviewsPage from "@/pages/ReviewsPage";
import LocationPage from "@/pages/LocationPage";
import LocationsHubPage from "@/pages/LocationsHubPage";
import BlogComingSoonPage from "@/pages/BlogComingSoonPage";
import GuidesHubPage from "@/pages/GuidesHubPage";
import GuidePage from "@/pages/GuidePage";
import ContactPage from "@/pages/ContactPage";
import MerchantIntegrationsPage from "@/pages/MerchantIntegrationsPage";
import MerchantPlatformPage from "@/pages/MerchantPlatformPage";
import PricingPage from "@/pages/PricingPage";
import BookingPage from "@/pages/BookingPage";
import ThankYouSignupPage from "@/pages/ThankYouSignupPage";
import AcceptQuotePage from "@/pages/AcceptQuotePage";
import PartnerLandingPage from "@/pages/PartnerLandingPage";
import PartnerWithUsPage from "@/pages/PartnerWithUsPage";
import StripeCostCheckPage from "@/pages/StripeCostCheckPage";
import ToolRoutes from "@/routes/ToolRoutes";
import LegalRoutes from "@/routes/LegalRoutes";
import NotFoundPage from "@/pages/NotFoundPage";

export default function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      {/* Products */}
      <Route path="/card-machines" element={<CardMachinesPage />} />
      <Route path="/card-machines/:product" element={<CardMachineProductPage />} />
      <Route path="/epos-systems" element={<EposSystemsPage />} />
      <Route path="/epos-systems/register" element={<EposRegisterPage />} />
      <Route path="/online-payments" element={<OnlinePaymentsPage />} />
      <Route path="/payment-gateway" element={<PaymentGatewayPage />} />
      <Route path="/virtual-terminal" element={<VirtualTerminalPage />} />
      <Route path="/online-ordering" element={<OnlineOrderingPage />} />
      <Route path="/merchant-cash-advance" element={<MerchantCashAdvancePage />} />
      <Route path="/industries" element={<IndustriesHubPage />} />
      <Route path="/industries/:industry" element={<IndustryPage />} />
      {/* About */}
      <Route path="/about" element={<AboutPage />} />
      <Route path="/purpose-beyond-payments" element={<PurposeBeyondPaymentsPage />} />
      {/* Campaign renamed twice: "Payments with Purpose" (Sep 2026) then
          "Payments Beyond Purpose" (Sep 2026, word order corrected). Both old
          indexed URLs redirect STRAIGHT to the current one — deliberately not
          chained through each other, so no visitor or crawler takes two hops.
          Note these are client-side redirects; the CloudFront 301s are still
          outstanding. */}
      <Route path="/payments-beyond-purpose" element={<Navigate to="/purpose-beyond-payments" replace />} />
      <Route path="/payments-with-purpose" element={<Navigate to="/purpose-beyond-payments" replace />} />
      <Route path="/about/:subpage" element={<AboutSubPage />} />
      {/* Partners */}
      <Route path="/partner-programme" element={<PartnerProgrammePage />} />
      <Route path="/careers" element={<CareersPage />} />
      <Route path="/refer-a-friend" element={<ReferAFriendPage />} />
      <Route path="/integrations" element={<MerchantIntegrationsPage />} />
      <Route path="/integrations/:platform" element={<MerchantPlatformPage />} />
      <Route path="/partners/integrations" element={<IntegrationHubPage />} />
      <Route path="/partners/integrations/:platform" element={<PlatformIntegrationPage />} />
      <Route path="/partners/api" element={<ApiPage />} />
      {/* Content */}
      <Route path="/case-studies" element={<CaseStudiesPage />} />
      <Route path="/case-studies/:study" element={<CaseStudyPage />} />
      <Route path="/faqs" element={<FAQsPage />} />
      <Route path="/reviews" element={<ReviewsPage />} />
      <Route path="/locations" element={<LocationsHubPage />} />
      <Route path="/locations/:location" element={<LocationPage />} />
      {/* Permanent comparison guides — maintained resource pages, deliberately
          NOT the blog (Gary, Sep 2026). Unknown slugs render the 404. */}
      <Route path="/guides" element={<GuidesHubPage />} />
      <Route path="/guides/:guide" element={<GuidePage />} />
      {/* Blog rebuild deferred post-launch — holding page on /blog and splat
          for any legacy deep-link URLs so inbound traffic gets 200 + noindex
          rather than 404. Original BlogPage component is preserved for the
          forward-port. */}
      <Route path="/blog" element={<BlogComingSoonPage />} />
      <Route path="/blog/*" element={<BlogComingSoonPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/book" element={<BookingPage />} />
      <Route path="/thank-you-for-signing-up" element={<ThankYouSignupPage />} />
      <Route path="/accept-quote" element={<AcceptQuotePage />} />
      {/* Hidden PPC landing pages — own minimal chrome, not linked from nav/footer */}
      <Route path="/landing/partner-programme" element={<PartnerLandingPage />} />
      {/* Stripe Cost Check merchant campaign (Sep 2026). noindex + absent
          from the sitemap until Gary signs off enquiry routing, the final
          canonical path and the GA4/GTM treatment — see the STAGING GATE
          note in StripeCostCheckPage.jsx. */}
      <Route path="/landing/stripe-cost-check" element={<StripeCostCheckPage />} />
      {/* Event landing page (Court Connect Padel QR) — own minimal chrome */}
      <Route path="/partner-with-us" element={<PartnerWithUsPage />} />
      {/* Tools & Calculators */}
      {ToolRoutes()}
      {/* Legal */}
      {LegalRoutes()}
      {/* Catch-all 404 — must be last so it only matches unhandled paths.
          noindex,nofollow via SEOHead (SEO_AUDIT_v2 PF-3). */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
